import Index from '@/views/index';

const webRouter = [
  {
    path: '/',
    component: Index,
    children: [
      {
        path: '',
        component: () => import('@/views/home'),
      },
    ],
  },
  {
    path: '/home',
    component: Index,
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/views/home'),
      },
    ],
  },
  {
    path: '/about',
    component: Index,
    children: [
      {
        path: '',
        name: 'About',
        component: () => import('@/views/about'),
      },
    ],
  },
  {
    path: '/news',
    component: Index,
    children: [
      {
        path: '',
        name: 'News',
        component: () => import('@/views/news'),
      },
    ],
  },
  {
    path: '/news/data',
    component: Index,
    children: [
      {
        path: '',
        name: 'NewsData',
        component: () => import('@/views/news/data.vue'),
      },
    ],
  },
  {
    path: '/education',
    component: Index,
    children: [
      {
        path: '',
        name: 'Education',
        component: () => import('@/views/education'),
      },
    ],
  },
  {
    path: '/product',
    component: Index,
    children: [
      {
        path: '',
        name: 'Product',
        component: () => import('@/views/product'),
      },
    ],
  },
  {
    path: '/product/data',
    component: Index,
    children: [
      {
        path: '',
        name: 'ProductData',
        component: () => import('@/views/product/data.vue'),
      },
    ],
  },
  {
    path: '/scheme',
    component: Index,
    children: [
      {
        path: '',
        name: 'Scheme',
        component: () => import('@/views/scheme'),
      },
    ],
  },
  {
    path: '/partner',
    component: Index,
    children: [
      {
        path: '',
        name: 'Partner',
        component: () => import('@/views/partner'),
      },
    ],
  },
  {
    path: '/404',
    component: Index,
    children: [
      {
        path: '',
        component: () => import('@/views/404/404.vue'),
      },
    ],
  },
  {
    path: '*',
    component: Index,
    children: [
      {
        path: '',
        component: () => import('@/views/404/404.vue'),
      },
    ],
  },
];

export default webRouter;




// WEBPACK FOOTER //
// ./src/router/module/webRouter.js